<script>
import ModelsIndex from "../index";
// import ModelChildrenIndex from "@/components/models/children-index";
import ModelCreate from "@/components/models/create";
import ModelEdit from "@/components/models/edit";
import ModelShow from "@/components/models/show";
import FormsModel from "@/components/forms/model";

import Swal from "sweetalert2";

export default {
  extends: ModelsIndex,
  components: {
    ModelCreate,
    ModelEdit,
    ModelShow
    // ModelChildrenIndex
  },
  props: {
    sectionTitle: {
      default() {
        return undefined;
      }
    },
    cardTitle: {
      default() {
        return undefined;
      }
    },
    cardAttrs: {
      default() {
        return {
          class: "card-plain"
          // noBody: true
        };
      }
    },
    resourceRoute: { default: "models.children" },
    modelVariable: { default: "child" },
    tableHeight: { type: Number, default: 530 },
    hideTableHeader: { type: Boolean, default: false },
    createProps: {
      default() {
        return {
          cardTitle: this.lodash.startCase(this.$t("children.singular")),
          resourceRoute: "models.children",
          modelVariable: "child",
          form: FormsModel
        };
      }
    },
    showProps: {
      default() {
        return {
          cardTitle: this.lodash.startCase(this.$t("children.singular")),
          resourceRoute: "models.children",
          modelVariable: "child"
        };
      }
    },
    editProps: {
      default() {
        return {
          cardTitle: this.lodash.startCase(this.$t("children.singular")),
          resourceRoute: "models.children",
          modelVariable: "child",
          form: FormsModel
        };
      }
    },
    parent: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      indexPage: true,
      createPage: false,
      showPage: false,
      editPage: false,

      storing: false,
      updating: false,
      deleting: false,
      title: null,
      items: [],
      page: 1,
      perPage: 15,
      search: "",
      sortBy: "name",
      sortDesc: false,

      newModel: {},
      model: {}
    };
  },
  computed: {
    modelMapped() {
      if (this.showProps.modelMapped) {
        return this.showProps.modelMapped;
      }
      return this.lodash.isEmpty(this.model)
        ? []
        : this.lodash.map(this.model || {}, (value, key) => ({
            key: this.lodash.startCase(this.$t(`${this.showProps.resourceRoute.split(".")[1]}.${key}`)),
            value: value
          }));
    }
  },
  methods: {
    handleCreate() {
      this.newModel = {};
      this.createPage = true;
    },
    handleShow(value) {
      this.model = value;
      // this.showPage = true;
    },
    handleEdit(value) {
      this.newModel = this.lodash.cloneDeep(value);
      this.editPage = true;
    },
    handleCreateBack() {
      this.createPage = false;
    },
    handleShowBack() {
      this.showPage = false;
    },
    handleShowEdit() {
      this.newModel = this.lodash.cloneDeep(this.model);
      this.editPage = true;
    },
    handleShowDelete() {
      this.handleDelete(this.lodash.cloneDeep(this.model));
    },
    handleEditBack() {
      this.editPage = false;
    },
    handleEditDelete() {
      this.handleDelete(this.lodash.cloneDeep(this.newModel));
    },
    storeSuccessAlert(something) {
      return Swal.fire({
        title: this.$t("Success") + "!",
        text: this.$t(`You've added {something}`, { something }),
        type: "success",
        showConfirmButton: false,
        timer: 1500
      });
    },
    store(value) {
      return Promise.resolve({ data: value });
    },
    handleStore(value) {
      this.storing = true;
      this.store(value)
        .then(() => this.storeSuccessAlert(this.getModelName(value)))
        .then(() => {
          this.isEditing = false;
          this.createPage = false;
          this.newModel = {};
          this.$emit("change", value);
        })
        .catch(error => this.failedAlert(error))
        .finally(() => {
          this.storing = false;
        });
    },
    updateSuccessAlert(something) {
      return Swal.fire({
        title: this.$t("Success") + "!",
        text: this.$t(`You've updated {something}`, { something }),
        type: "success",
        showConfirmButton: false,
        timer: 1500
      });
    },
    update(value) {
      return Promise.resolve({ data: value });
    },
    handleUpdate(value) {
      this.updating = true;
      this.update(value)
        .then(() => this.updateSuccessAlert(this.getModelName(value)))
        .then(() => {
          this.isEditing = false;
          this.editPage = false;
          this.showPage = false;
          this.$set(this, "model", value);
          this.$emit("change", value);
          this.newModel = {};
        })
        .catch(error => this.failedAlert(error))
        .finally(() => {
          this.updating = false;
        });
    },
    handleDelete(value) {
      this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete(value)
            .then(() => {
              this.showPage = false;
              this.editPage = false;
              this.newModel = {};
              this.$emit("change", value);
              this.$nextTick(() => {
                this.$refs.table.$refs.table.refresh();
              });
            })
            .then(() => this.deleteSuccessAlert(this.getModelName(value)))
            .catch(error => {
              this.failedAlert(error);
              return null;
            });
        }
      });
    }
  }
};
</script>

<template>
  <div class="row">
    <model-index
      v-if="indexPage && !createPage && !editPage && !showPage"
      ref="table"
      class="col-12"
      :loading="loading"
      v-bind="$props"
      :columns="columns"
      :busy.sync="busy"
      :models-paginated="modelsPaginated"
      :models="models"
      :page.sync="page"
      :per-page.sync="perPage"
      :from="from"
      :total="totalFiltered"
      :search.sync="search"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @create-click="handleCreate"
      @show-click="handleShow"
      @edit-click="handleEdit"
      @delete-click="handleDelete"
    >
      <template #header>
        <h6 class="mb-0">Header Slot</h6>
      </template>
    </model-index>
    <model-create
      v-if="createPage"
      class="col-12"
      :loading="loading"
      :storing="storing"
      v-bind="createProps"
      v-model="newModel"
      @back-click="handleCreateBack"
      @store-click="handleStore"
    >
    </model-create>
    <model-edit
      v-else-if="editPage"
      class="col-12"
      :loading="loading"
      :updating="updating"
      :deleting="deleting"
      v-bind="editProps"
      v-model="newModel"
      :key="getModelKey(newModel)"
      @back-click="handleEditBack"
      @update-click="handleUpdate"
      @delete-click="handleEditDelete"
    >
    </model-edit>
    <model-show
      v-else-if="showPage"
      class="col-12"
      :loading="loading"
      v-bind="showProps"
      :model-mapped="modelMapped"
      @back-click="handleShowBack"
      @edit-click="handleShowEdit"
      @delete-click="handleShowDelete"
    >
    </model-show>
  </div>
</template>

<style scoped lang="scss">
@import "~@/design/app.scss";
::v-deep {
  .table-model {
    @extend .jds-table;
    table {
      @extend .table-zebra;
    }
  }
}
</style>
